import { FC } from 'react';
import type { TNftCardProps } from './';
import { AllNftCardSkeleton } from './AllNftCard/Skeleton';
import { VeniceNftCardSkeleton } from './VeniceNftCard/Skeleton';

export const NftCardSkeleton: FC<Partial<TNftCardProps>> = ({
  size = 'medium',
  className,
  flexible = false,
  veniceModeView = false
}) => {
  return veniceModeView ? (
    <VeniceNftCardSkeleton className={className} flexible={flexible} />
  ) : (
    <AllNftCardSkeleton size={size} className={className} flexible={flexible} />
  );
};
